export default __webpack_public_path__ + "static/media/minsal_ventas_directas.64265e17.png";